import { render, staticRenderFns } from "./number-slider-dynamic-images.vue?vue&type=template&id=2c9d8046&"
import script from "./number-slider-dynamic-images.vue?vue&type=script&lang=ts&"
export * from "./number-slider-dynamic-images.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9d8046')) {
      api.createRecord('2c9d8046', component.options)
    } else {
      api.reload('2c9d8046', component.options)
    }
    module.hot.accept("./number-slider-dynamic-images.vue?vue&type=template&id=2c9d8046&", function () {
      api.rerender('2c9d8046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/question-components/number-slider-dynamic-images/number-slider-dynamic-images.vue"
export default component.exports